import { apiRoutes, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type ReferencedataDto = EntityRecord;
export type ReferencedataCreateRequest = EntityCreateRequest;
export type ReferencedataUpdateRequest = EntityUpdateRequest;

export const referenceDataApi: CrudApi<ReferencedataDto, ReferencedataCreateRequest, ReferencedataUpdateRequest> = createStandardCrudApi({
  list: apiRoutes.referenceValues.list,
  get: apiRoutes.referenceValues.get,
  create: apiRoutes.referenceValues.create,
  update: apiRoutes.referenceValues.update,
  delete: apiRoutes.referenceValues.delete,
  activate: apiRoutes.referenceValues.activate,
  deactivate: apiRoutes.referenceValues.deactivate,
  schema: apiRoutes.referenceValues.schema,
  validate: apiRoutes.referenceValues.validate,
  dependencies: apiRoutes.referenceValues.dependencyCheck,
  dropdown: apiRoutes.referenceValues.dropdownOptions,
});
